import { useModals } from "ModalProvider";
import Button from "components/base/Button";
import { useContext } from "react";
import LabTestReportsSelector from "components/shared/LabTestReportsSelector";
import ComplianceCertificatesSelector from "components/shared/ComplianceCertificatesSelector";
import { ProductContext } from "./ProductForm";

const ComplianceView = () => {
  const { product, setProduct } = useContext(ProductContext);
  const modal = useModals();

  const certificates = product.complianceCertificates || [];
  const testReports = product.labTestReports || [];

  function removeCertificate(certificateId) {
    setProduct((prev) => ({
      ...prev,
      complianceCertificates: (prev.complianceCertificates || []).filter(
        (certificate) => certificate.id !== certificateId,
      ),
    }));
  }

  function removeTestReport(reportId) {
    setProduct((prev) => ({
      ...prev,
      labTestReports: (prev.labTestReports || []).filter(
        (report) => report.id !== reportId,
      ),
    }));
  }

  return (
    <div className="card">
      <h5>Compliance</h5>

      <div className="mt-4 space-y-6">
        <div className="space-y-3">
          <label>Certificates</label>
          {certificates.length > 0 ? (
            <div className="-mx-2">
              <table className="with-line">
                <tbody>
                  {certificates.map((certificate) => (
                    <tr key={certificate.id}>
                      <td>
                        <div className="flex items-center justify-between">
                          <div>
                            {certificate.certificateNumber ? (
                              <div className="text-xs opacity-70">
                                #{certificate.certificateNumber}
                              </div>
                            ) : null}
                            <a
                              className="link"
                              href={`/certificates/${certificate.id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {certificate.title || "-"}{" "}
                              {certificate.certificateType
                                ? `(${certificate.certificateType})`
                                : ""}
                            </a>
                          </div>
                          <Button
                            trash
                            onClick={() => removeCertificate(certificate.id)}
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-xs opacity-60">No certificates selected.</div>
          )}

          <Button
            onClick={() =>
              modal.present({
                title: "Choose Certificates",
                center: true,
                children: (
                  <ComplianceCertificatesSelector
                    defaultSelectedCertificates={certificates}
                    onDone={(selectedCertificates) => {
                      setProduct((prev) => ({
                        ...prev,
                        complianceCertificates: selectedCertificates,
                      }));
                      modal.hide();
                    }}
                  />
                ),
              })
            }
          >
            + Choose Certificates
          </Button>
        </div>

        <div className="space-y-3">
          <label>Lab Test Reports</label>
          {testReports.length > 0 ? (
            <div className="-mx-2">
              <table className="with-line">
                <tbody>
                  {testReports.map((report) => (
                    <tr key={report.id}>
                      <td>
                        <div className="flex items-center justify-between">
                          <div>
                            {report.reportNumber ? (
                              <div className="text-xs opacity-70">
                                #{report.reportNumber}
                              </div>
                            ) : null}
                            <a
                              className="link"
                              href={`/test-reports/${report.id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {report.title || "-"}
                            </a>
                          </div>
                          <Button trash onClick={() => removeTestReport(report.id)} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-xs opacity-60">No test reports selected.</div>
          )}

          <Button
            onClick={() =>
              modal.present({
                title: "Choose Test Reports",
                center: true,
                children: (
                  <LabTestReportsSelector
                    defaultSelectedTestReports={testReports}
                    onDone={(selectedTestReports) => {
                      setProduct((prev) => ({
                        ...prev,
                        labTestReports: selectedTestReports,
                      }));
                      modal.hide();
                    }}
                  />
                ),
              })
            }
          >
            + Choose Test Reports
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ComplianceView;
